import { render } from "./ClassCardsList.vue?vue&type=template&id=0a2c4678&scoped=true"
import script from "./ClassCardsList.vue?vue&type=script&lang=js"
export * from "./ClassCardsList.vue?vue&type=script&lang=js"

import "./ClassCardsList.vue?vue&type=style&index=0&id=0a2c4678&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2c4678"]])

export default __exports__